"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectResource = void 0;
const chroma_js_1 = __importDefault(require("chroma-js"));
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const configContext_1 = require("../../context/configContext");
require("./MultiSelect.scss");
const MultiSelectResource = (props) => {
    const config = (0, configContext_1.useConfig)();
    const allResources = config.resources.map((resource) => ({
        value: resource.id,
        label: resource.resourceItem.title,
        color: resource.color,
    }));
    const selectedResources = allResources.filter((resource) => props.selectedResourceIds.includes(resource.value));
    const selectAllOption = {
        value: "-all-",
        label: "Alle",
        color: "black",
    };
    const colourStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: "white",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = (0, chroma_js_1.default)(data.color);
            return {
                ...styles,
                color: "#EDEDED",
                backgroundColor: data.color,
                ":hover": {
                    backgroundColor: color.darken().css(),
                    cursor: "pointer",
                },
            };
        },
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                color: "#EDEDED",
                backgroundColor: data.color,
            };
        },
        multiValueLabel: (styles, { data, isDisabled, isFocused }) => {
            return {
                ...styles,
                color: "#EDEDED",
                backgroundColor: data.color,
            };
        },
        multiValueRemove: (styles, { data }) => {
            const color = (0, chroma_js_1.default)(data.color);
            return {
                ...styles,
                color: "#EDEDED",
                backgroundColor: data.color,
                ":hover": {
                    backgroundColor: color.darken().css(),
                },
            };
        },
    };
    return (react_1.default.createElement(react_select_1.default, { className: "multi-select", onChange: (allSelected, actionMeta) => {
            if (allSelected && Array.isArray(allSelected)) {
                if (allSelected.includes(selectAllOption)) {
                    props.onSelectedResourceIdsChange(allResources.map((s) => s.value));
                }
                else {
                    props.onSelectedResourceIdsChange(allSelected.map((s) => s.value));
                }
            }
            else {
                props.onSelectedResourceIdsChange([]);
            }
        }, value: selectedResources, closeMenuOnSelect: false, isSearchable: true, isMulti: true, options: selectedResources.length < allResources.length
            ? [selectAllOption, ...allResources]
            : allResources, styles: colourStyles }));
};
exports.MultiSelectResource = MultiSelectResource;
